import { useState } from 'react';
import bird from '../img/approve.png';

function ContactForm() {
    const [emailError, setEmailError] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [answers, setAnswers] = useState({
        services: [],        // multiple choice
        timeline: '',          // single choice
        budget: '',        // single choice
        message: '',         // text
        name: '',           //contact name
        email: '',          //email
        phone: ''           //phone number
    });

    const showSuccessMessage = () => {
        
    }

  // Multiple choice — toggle on/off
    const toggleService = (value) => {
        let box = document.getElementById(value);
        setAnswers(prev => ({
        ...prev,
        services: prev.services.includes(value)
            ? prev.services.filter(s => s !== value)
            : [...prev.services, value]
        }));

    };

    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const hasEmail = emailRegex.test(value);
        setEmailError(hasEmail ? '' : 'Please enter a valid email address');
    };

    const handleSubmit = () => {
        let servicesBlock = document.getElementById('ErrorMessageServices');
        let timelineBlock = document.getElementById('ErrorMessageTimeline');
        let budgetBlock = document.getElementById('ErrorMessageBudget');
        let messageBlock = document.getElementById('ErrorMessageText');

        servicesBlock.style.display = "none";
        timelineBlock.style.display = "none";
        budgetBlock.style.display = "none";
        messageBlock.style.display = "none";

        if (answers.services.length == 0) {
            servicesBlock.style.display = "block";
            servicesBlock.style.color = "red";
            return;
        }
        if (answers.timeline.length == 0) {
            timelineBlock.style.display = "block";
            timelineBlock.style.color = "red";
            return;
        }
        if (answers.budget.length == 0) {    
            budgetBlock.style.display = "block";
            budgetBlock.style.color = "red";
            return;
        }
        if (answers.message.length == 0) {
            messageBlock.style.display = "block";
            messageBlock.style.color = "red";
            return;
        }

        let divs = document.getElementsByClassName('QWrapper');
        for(let i = 0; i < divs.length; i++) {
            divs[i].style.display = "none";
        }
        document.getElementById('LastQSectionWrapper').style.display = "block";
    };

    const handleFullSubmit = async () => {
        let emailBlock = document.getElementById('ErrorMessageEmail');
        let nameBlock = document.getElementById('ErrorMessageName');

        nameBlock.style.display = "none";
        emailBlock.style.display = "none";

        if(answers.name.length == 0) {
            nameBlock.style.display = "block";
            nameBlock.style.color = "red";
            return;
        }
        if (emailError || answers.email.length == 0){
            console.log(emailError);
            emailBlock.style.display = "block";
            emailBlock.style.color = "red";
            return;
        } 

        const formData = new FormData();
        formData.append("services", answers.services.join(", ")); // array → string
        formData.append("timeline", answers.timeline);
        formData.append("budget",   answers.budget);
        formData.append("message",  answers.message);
        formData.append("name",     answers.name);
        formData.append("email",    answers.email);
        formData.append("phone",    answers.phone);

        try {
            const response = await fetch("https://tak-studio.com/submit.php", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (result.success) {
                setShowSuccess(true);
                setTimeout(() => setShowSuccess(false), 3000);
            } else {
                console.error("Error:", result.error);
            }
        } catch (error) {
            console.error("Request failed:", error);
        }

    }

    return (
        <div className='QBigWrapper'>
            {/* 1. Multiple choice */}
            <div className='QWrapper'  id='QBigWrapper'>
                <div className='QHeaderWrapper'>
                    <p className='Numeric'>(01/04)</p>
                    <p className='QHeader' id='QHeader'>WHAT DO YOU WANT <br className='MobileHidden'/>TO BUILD? *</p>
                </div>
                <div className='AnswerVars'>
                    {['Website', 'Web App', '3D Visualisation', 'AI Content', 'Brand Identity', 'Other'].map(option => {
                        const selected = answers.services.includes(option);
                        return(
                            <button
                            key={option}
                            onClick={() => toggleService(option)}
                            className='AnswerVar AnswerBtn'>
                                <div className='Checkbox' id={option} 
                                    style={{ background: selected ? '#fff' : 'transparent' }}/>                                
                                {option}
                            </button>
                        );
                    })}
                </div>
            </div>
            <p className='ErrorMessage' id='ErrorMessageServices'>Please choose at least one option</p>
            {/* 2. Single choice */}
            <div className='QWrapper'  id='QBigWrapper'>
                <div className='QHeeaderWrapper'>
                    <p className='Numeric'>(02/04)</p>
                    <p className='QHeader'>What's your<br/> timeline? *</p>
                </div>
                <div className='AnswerVars'>
                    {['ASAP — within 1 month', '1–3 months', '3–6 months', 'Flexible / Not sure'].map(option => {
                        const selected = answers.timeline.includes(option);
                        return(
                            <button
                            key={option}
                            onClick={() => setAnswers(prev => ({ ...prev, timeline: option }))}
                            style={{ background: answers.budget === option ? '#111' : 'none' }}
                            className='AnswerBtn'
                            >
                                <div className='Checkbox SingleChoiceCircle' 
                                    style={{ background: selected ? '#fff' : 'transparent' }}
                                ></div>
                                {option}
                            </button>
                        );
                    })}
                </div>
            </div>
            <p className='ErrorMessage' id='ErrorMessageTimeline'>Please choose a time span</p>

            {/* 3. Single choice */}
            <div className='QWrapper'  id='QBigWrapper'>
                <div className='QHeeaderWrapper'>
                    <p className='Numeric'>(03/04)</p>
                    <p className='QHeader'>What's your<br/> budget? *</p>
                </div>
                <div className='AnswerVars'>
                    {['< $500', '$500 — $1,000', '$1,000 — $5,000', '> $5,000'].map(option => {
                        const selected = answers.budget.includes(option);
                        return (
                        <button
                            key={option}
                            onClick={() => setAnswers(prev => ({ ...prev, budget: option }))}
                            style={{ background: answers.timeline === option ? '#111' : 'none' }}
                            className='AnswerBtn'
                            >
                                <div className='Checkbox SingleChoiceCircle'
                                    style={{ background: selected ? '#fff' : 'transparent' }}
                                ></div>
                                {option}
                            </button>
                        );
                    })}
                </div>
            </div>
            <p className='ErrorMessage' id='ErrorMessageBudget'>Please choose your budget</p>

            {/* 4. Text */}
            
            <div className='QWrapper LastQWrapper' id='LastQWrapper'>
                <p className='Numeric'>(04/04)</p>
                <p className='QHeader'>about your <br/>project*</p>
                <textarea
                    value={answers.message}
                    onChange={e => setAnswers(prev => ({ ...prev, message: e.target.value }))}
                    placeholder="Tell us about your project, goals, and any details…"
                    className='TxtAnswer'
                />
                <p className='ErrorMessage' id='ErrorMessageText'>Please describe your project</p>

                <div className='BtnWrapper'>

                    <button onClick={handleSubmit} className='ContactBtn'>Send Message →</button>
                    <p className='TxtNearBtn'>Or reach us at hello@tak-studio.com</p>
                </div>
            </div>

            <div className='QWrapper LastQWrapper Hidden' id='LastQSectionWrapper'>
                <p className='Numeric'>(01/01)</p>
                <p className='QHeader'>your data*</p>
                <textarea
                    value={answers.name}
                    onChange={e => setAnswers(prev => ({ ...prev, name: e.target.value }))}
                    placeholder="Your name..."
                    className='TxtAnswer'
                    required
                />
                <p className='ErrorMessage' id='ErrorMessageName'>Please enter your/company name</p>
                <textarea
                    value={answers.email}
                    onBlur={e => 
                        validateEmail(e.target.value)
                    }  
                    onChange={e => 
                        setAnswers(prev => ({ ...prev, email: e.target.value }))
                    }
                    placeholder="Your Email..."
                    className='TxtAnswer'
                    required
                />
                <p className='ErrorMessage' id='ErrorMessageEmail'>Please enter the real email</p>
                <textarea
                    value={answers.phone}
                    onChange={e => setAnswers(prev => ({ ...prev, phone: e.target.value }))}
                    placeholder="Phone number..."
                    className='TxtAnswer'
                />
                <button onClick={handleFullSubmit} className='ContactBtn'>Send Message →</button>
            </div>

            <div className={showSuccess ? 'Success Visible' : 'Success'} id='Success'>
                <div className='p'>
                    <p>
                        Thanks for your contact!
                    </p>
                    <img src={bird}/>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;